<template>
  <div class="remarket-cont-info-page">
    <CustomTable
      title="Список шоурумов"
      :rowsData="showroomsData"
      :columns="showroomsColumns"
      :loading="loading"
      :custom-body="true"
      style="margin-bottom: 50px"      
    >
      <!-- <template #top-right>
        <div class="header-actions">
          <q-btn
            label="Добавить шоурум"
            color="primary"
            @click="this.showAddShowroomModal"
            class="action-btn"
            icon="add"
          />
        </div>
      </template> -->
      <template #customBody="props">
        <q-tr @click="() => this.toggleCollapse(props.row.front_show_room_id)">
          <custom-table-cell align="center">
            {{ props.row.i }}
          </custom-table-cell>
          <custom-table-cell align="center">
            {{ props.row.city_name }}
          </custom-table-cell>
          <custom-table-cell align="center">
            {{ props.row.resident_name }}
          </custom-table-cell>
          <custom-table-cell align="center">
            {{ props.row.address }}
          </custom-table-cell>
          <custom-table-cell align="center">
            <Clickable :href="props.row.video_url" :link="true">
              {{ props.row.video_url }}
            </Clickable>
          </custom-table-cell>
          <custom-table-cell align="center">
            {{ props.row.order_num }}
          </custom-table-cell>
          <custom-table-cell align="center">
            <CheckOrClose only-true :value="props.row.is_remarket" />
          </custom-table-cell>
          <custom-table-cell align="center">
            <q-btn
              @click.stop="() => this.toggleCollapse(props.row.front_show_room_id)"
              :color="collapsedItems[props.row.front_show_room_id] ? 'red' : 'green'"
              size="md"
              class="toggle-btn"
              rounded
              flat
            >
              <i
                class="fa-solid fa-angle-down"
                :class="{ rotated: collapsedItems[props.row.front_show_room_id] }"
              ></i>
            </q-btn>
          </custom-table-cell>
        </q-tr>
        <q-td v-if="collapsedItems[props.row.front_show_room_id]" colspan="8">
          <CollapseBlock
            :onChange="() => this.toggleCollapse(props.row.front_show_room_id)"
            :collapsedProps="!this.collapsedItems[props.row.front_show_room_id]"
            :controlMode="true"
            hideExpand
          >
            <CustomTable
              :title="computedPhotosTitle"
              :rowsData="shwrmPhotosData"
              :columns="shwrmPhotosColumns"
              :loading="loading"
              :custom-body="true"
              :sticky-header="true"
            >
              <template #top-right>
                <div class="header-actions">
                  <q-btn
                    label="Добавить фото"
                    color="primary"
                    @click="this.showAddPhotoModal(props.row.front_show_room_id)"
                    class="action-btn"
                    icon="add"
                  />
                </div>
              </template>
              <template #customBody="innerProps">
                <q-tr>
                  <custom-table-cell align="center">
                    {{ innerProps.row.i }}
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    <a
                      :href="`${FILE_URL_OFFICE}${innerProps.row.photo_url}`"
                      target="_blank"
                    >
                      <CustomImg
                        :src="innerProps.row.photo_url_mini || innerProps.row.photo_url"
                        :showDefaultImg="false"
                        style="max-height: 150px"
                        alt="showroom_photo"
                      />
                    </a>
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    <CheckOrClose :value="innerProps.row.is_active" />
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    <CheckOrClose only-true :value="innerProps.row.is_main" />
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    {{ innerProps.row.order_num }}
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    <CustomIcon
                      icon="edit"
                      green
                      @click="() => showUpdPhotoModal(innerProps.row)"
                    />
                  </custom-table-cell>
                  <custom-table-cell align="center">
                    <CustomIcon
                      icon="trash"
                      :approve-mode="true"
                      :loading="
                        deletePhotosLoading[
                          innerProps.row.front_show_room_photo_id
                        ]
                      "
                      :approve="
                        () =>
                          handleDeletePhoto(
                            innerProps.row.front_show_room_photo_id
                          )
                      "
                    />
                  </custom-table-cell>
                </q-tr>
              </template>
            </CustomTable>
          </CollapseBlock>
        </q-td>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import CustomImg from "@/components/common/CustomImg";
import CustomUploader from "@/components/form/CustomUploader";
import Clickable from "@/components/common/Clickable";
import CheckOrClose from "@/components/common/CheckOrClose";
import CollapseBlock from "@/components/common/CollapseBlock";

import { MODAL_NAMES, FILE_URL_OFFICE } from "@/constants";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import {
  getShowrooms,
  getShowroomPhotos,
  updShowroomPhoto,
  deleteShowroomPhoto,
  showroomsColumns,
  shwrmPhotosColumns,
} from "@/views/Showrooms/services";

export default {
  name: "Showrooms",
  components: {
    CustomTable,
    CustomTableCell,
    CustomIcon,
    CustomImg,
    CustomUploader,
    Clickable,
    CheckOrClose,
    CollapseBlock,
  },
  data() {
    return {
      FILE_URL_OFFICE,
      loading: false,
      deletePhotosLoading: {},
      showroomsData: [],
      showroomsColumns,
      shwrmPhotosData: [],
      shwrmPhotosColumns,
      temp_front_show_room_id: "",
      collapsedItems: {},
    };
  },
  computed: {
    computedPhotosTitle() {
      if (this.temp_front_show_room_id === 34) {
        return "Фотографии шоурума Remarket";
      } else {
        return "Фоторафии шоурума";
      }
    },
  },
  methods: {
    async getData() {
      this.loading = true;
      const res = await getShowrooms();
      this.loading = false;
      console.log(res);

      if (!res) return;
      this.showroomsData = res;
    },
    async getPhotos(front_show_room_id) {
      this.loading = true;
      const res = await getShowroomPhotos(front_show_room_id);
      this.loading = false;
      if (!res) return;
      this.shwrmPhotosData = res;
    },
    showAddPhotoModal(front_show_room_id) {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.ADD_SHOWROOM_PHOTO, {
          onSubmit: (body) => this.handlePhotoUpd(body),
          title: "Добавить фото",
          body: { front_show_room_id },
        })
      );
    },
    showUpdPhotoModal(row) {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.ADD_SHOWROOM_PHOTO, {
          onSubmit: (body) => this.handlePhotoUpd(body),
          title: "Добавить фото",
          body: row,
        })
      );
    },
    async handlePhotoUpd(body) {
      const res = await updShowroomPhoto(body);
      if (!res) return;
      this.shwrmPhotosData = res;
      if (!!res.front_show_room_photo_id) {
        this.showSucceedSnackbar("Фото успешно обновлено");
      } else {
        this.showSucceedSnackbar("Фото успешно добавлено");
      }
      this.$store.commit(appActions.closeModal());
    },
    async handleDeletePhoto(showroomPhotoId) {
      this.deletePhotosLoading = {
        ...this.deletePhotosLoading,
        [showroomPhotoId]: true,
      };
      const res = await deleteShowroomPhoto(showroomPhotoId);
      this.deletePhotosLoading = {
        ...this.deletePhotosLoading,
        [showroomPhotoId]: false,
      };
      if (res) {
        this.shwrmPhotosData = this.shwrmPhotosData.filter(
          (showroom) => showroom.front_show_room_photo_id !== showroomPhotoId
        );
        this.showSucceedSnackbar("Фото успешно удалено");
      }
    },
    async toggleCollapse(front_show_room_id) {
      this.collapsedItems[front_show_room_id] = !this.collapsedItems[front_show_room_id];
      this.temp_front_show_room_id = front_show_room_id;
      if (!this.collapsedItems[front_show_room_id]) return;
      
      this.innerTableLoading = true;
      await this.getPhotos(front_show_room_id);
    },
  },
  async mounted() {
    await this.getData();
    if (this.temp_front_show_room_id === "") {
      this.temp_front_show_room_id = 34;
      this.toggleCollapse(this.temp_front_show_room_id)
    } // Ремаркет Шоурум 
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar };
  },
};
</script>

<style scoped lang="scss">
.remarket-cont-info-page {
  padding: 20px;
}

.contractor-info {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contractor-header {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.logo-container {
  position: relative;
  width: 150px;
  height: 150px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;

  &:hover .edit-overlay {
    opacity: 1;
  }
}

.contractor-logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-width: none !important;

  &.has-logo {
    max-width: none !important;
    filter: none !important;
    opacity: 1 !important;
  }
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  color: white;
}

.info-container {
  flex: 1;
}

.contractor-name {
  margin: 0 0 10px 0;
  font-size: 24px;
}

.description-container {
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

.description-text {
  white-space: pre-wrap;
  line-height: 1.5;
}

.logo-uploader {
  margin-top: 10px;
  max-width: 300px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  margin-right: 10px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h2 {
    margin: 0;
  }
}

.header-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  margin-left: 10px;
}

.toggle-btn {
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.toggle-btn:hover {
  background-color: #138496;
  color: white;
  transform: scale(1.1);
  cursor: pointer;
}

.toggle-btn i {
  transition: transform 0.2s ease;
}

.toggle-btn i.rotated {
  transform: rotate(180deg);
}
</style>
